import { render } from "./DeclaracaoPagamento.vue?vue&type=template&id=6efb418a&scoped=true"
import script from "./DeclaracaoPagamento.vue?vue&type=script&lang=js"
export * from "./DeclaracaoPagamento.vue?vue&type=script&lang=js"

import "./DeclaracaoPagamento.vue?vue&type=style&index=0&id=6efb418a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efb418a"]])

export default __exports__